<template>
    <BModal
        v-model:show="show"
        title=""
        hide-header-close
        body-class="p-0"
        :modal-class="'modal-alert'"
        :hide-footer="!showButtons"
        @hide="handleCancel"
    >
        <template #title>
            {{ title }}
        </template>
        
        <div class="description">
            {{ html }}
        </div>
        
        <template #footer>
            <div v-if="showButtons" class="main_buttons">
                <BButton size="lg" class="me-2" variant="primary" @click="handleOk">
                    Гаразд
                </BButton>
                <BButton size="lg" variant="danger" @click="handleCancel">
                    Скасувати
                </BButton>
            </div>
            <div v-else class="disable_button" />
        </template>
    </BModal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue-next'

export default {
    name: 'ConfirmModal',
    components: {
        BModal,
        BButton
    },
    data() {
        return {
            show: false,
            worker: null,
            title: 'IMC TITLE',
            html: '',
            showButtons: true
        }
    },
    mounted() {
        EventBus.$on('show_imc_confirm', this.onShow);
        EventBus.$on('close_imc_confirm', this.onClose);
    },
    beforeUnmount() {
        EventBus.$off('show_imc_confirm', this.onShow);
        EventBus.$off('close_imc_confirm', this.onClose);
    },
    methods: {
        
        onShow(event) {
            this.title = event.title
            this.html = event.html
            this.worker = event.worker ?? null
            this.showButtons = event?.params?.show_buttons !== false
            this.show = true
        },
        
        onClose(event) {
            const delay = event.detail?.delay || 0
            setTimeout(() => (this.show = false), delay)
        },
        
        handleOk() {
            if (this.worker?.resolve) this.worker.resolve('OK')
            this.show = false
        },
        
        handleCancel() {
            if (this.worker?.reject) this.worker.reject('no')
            this.show = false
        }
    }
}
</script>

<style scoped>
.main_buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}
</style>
